import { useNavigate } from "react-router-dom";
import { useAuth } from "./security/Authcontext";
import "./WelcomePage.css";

function WelcomePage() {
  const navigate = useNavigate();
  const authContext = useAuth();
  const username = authContext.usrname;
  const fullname = authContext.fullname || username;

  return (
    <div className="welcome-wrapper">
      {/* Hero Section */}
      <div className="welcome-card">
        <h1 className="welcome-title">
          Welcome back, <span>{fullname}</span>
        </h1>

        <p className="welcome-subtitle">
          Stay organized, focused, and in control of your daily tasks.
        </p>

        <div className="welcome-actions">
          <button
            className="btn-primary"
            onClick={() => navigate("/list-todos")}
          >
            📋 View My Tasks
          </button>

          <button
            className="btn-secondary"
            onClick={() => navigate("/add-todos")}
          >
            ➕ Create New Task
          </button>
        </div>
      </div>

      {/* Feature Cards */}
      <div className="features">
        <div className="feature-card">
          <h3>Organize</h3>
          <p>Create and manage your tasks efficiently.</p>
        </div>

        <div className="feature-card">
          <h3>Track</h3>
          <p>Keep an eye on deadlines and progress.</p>
        </div>

        <div className="feature-card">
          <h3>Achieve</h3>
          <p>Mark tasks as done and stay productive.</p>
        </div>
      </div>
    </div>
  );
}

export default WelcomePage;
